// extracted by mini-css-extract-plugin
module.exports = {"root":"AuctionsList_root__INQ9N","empty":"AuctionsList_empty__15Rhb","date":"AuctionsList_date__1Z14V"};